import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Numeric.module.css';

export type NumericProps = HTMLAttributes<HTMLSpanElement> & {
  children: ReactNode;
};

/** Tabular numbers in `--wp-font-mono` — amounts, quantities, SKUs. */
export function Numeric({ className, children, ...rest }: NumericProps) {
  return (
    <span className={cx(styles.root, className)} {...rest}>
      {children}
    </span>
  );
}
